import { IDocumentData } from '@app/transactions/components/upload-document/upload-document.component';

export const upload_screenshot_model: Array<IDocumentData> = [
    {
        document_type: 'screenshot',
        title: {
            pending: 'Tus comprobantes de pago están en revisión.',
            approved: 'Tus comprobantes de pago fueron aprobados.',
            default: 'Aguardamos los comprobantes de tus pagos.'
        },
        why_go_up: `<p>
                Marcaste que enviaste el saldo, ahora necesitamos los comprobantes de tus pagos. Recuerda
                que deben ser desde tu cuenta.
            </p>`,
        documents_qty_min: 1,
        documents_qty_max: 30,
        gif: '',
        examples_document: []
    }
];
